import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"rate-app",
	() => import("../ui/rate-app-popup"),
)
